// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"ellipses_ellipse__0wYoI","fadeIn":"ellipses_fadeIn__fPFvG","text_more":"ellipses_text_more__TWLFr"};